import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-repair-record',
  templateUrl: './repair-record.component.html',
  styleUrls: ['./repair-record.component.sass'],
})
export class RepairRecordComponent {
  repairForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<RepairRecordComponent>
  ) {
    this.repairForm = this.fb.group({
      relocation: ['', Validators.required],
      value: [
        null,
        [
          Validators.required,
          Validators.min(1),
          Validators.pattern('^[0-9]*$'),
        ],
      ],
    });
  }

  handleCancel(): void {
    this.dialogRef.close();
  }

  handleConfirm(): void {
    if (this.repairForm.valid) {
      this.dialogRef.close(this.repairForm.value);
    }
  }
}
